module.exports = __webpack_public_path__ + "img/dsci0097.65254eae.jpg";